const utility = {
    cursor: {
        pointer: { cursor: 'pointer' },
        notAllowed: {
            cursor: 'pointer',
            pointerEvents: 'none'
        }
    },
    size: {
        fullSize: {
            width: '100%',
            height: '100%'
        },
        fullWidthStyles: {
            width: '100%'
        },
        fullHeightStyles: {
            height: '100%'
        }
    },
    accessiblyHidden: {
        position: 'absolute',
        left: 0,
        top: 0,
        opacity: 0
    }
};
export default utility;
//# sourceMappingURL=utility.js.map